<template>
  <div class="bank-attachment-row">
    <div class="bank-attachment-row__list">
      <AttachmentList
        :attachments="attachmentsForType"
        :attachmentType="attachmentType"
        v-on:attachment-list:delete="onDelete"
      />
    </div>
    <div class="bank-attachment-row__upload">
      <DropzoneUpload
        :complete="isUploadComplete"
        :parentId="project.id"
        :parentType="attachmentType"
        :uploadCallback="onUpload"
        :multiUpload="true"
        v-on:dropzone-upload:reset="isUploadComplete = false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DropzoneUpload from '@/components/DropzoneUpload';
import AttachmentList from '@/components/AttachmentList';

export default {
  name: 'BankAttachmentUpload',
  components: {
    DropzoneUpload,
    AttachmentList,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    attachmentType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isUploadComplete: false,
    };
  },
  computed: {
    attachmentsForType() {
      const bankAttachments = this.project?.bank?.attachments;
      if (!bankAttachments) {
        return [];
      }
      return bankAttachments.filter(
        (attachment) => attachment.attachmentType === this.attachmentType
      );
    },
  },
  methods: {
    ...mapActions(['uploadProjectDynamicAttachment', 'deleteProjectDynamicAttachment']),

    async onUpload(payload) {
      for (const file of payload.files) {
        await this.uploadProjectDynamicAttachment({
          file,
          parentId: payload.parentId,
          parentType: payload.parentType,
        });
      }
    },

    async onDelete(event) {
      await this.deleteProjectDynamicAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
      });
    },
  },
  mounted() {
    this.$store.subscribeAction({
      after: (action) => {
        if (
          action.type === 'uploadProjectDynamicAttachment' &&
          action.payload?.parentType === this.attachmentType
        ) {
          this.isUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style scoped lang="scss">
.bank-attachment-row {
  display: grid;
  grid-template-columns: minmax(0, 6fr) minmax(0, 4fr);
  gap: 1rem;
  align-items: start;
  min-width: 0;
}

.bank-attachment-row__list {
  min-width: 0;
}

.bank-attachment-row__upload {
  min-width: 0;
}

@media (max-width: 992px) {
  .bank-attachment-row {
    grid-template-columns: 1fr;
  }
}
</style>
